'use strict';

if (window.registerOutboundEntryController) {
    window.registerOutboundEntryController('outboundTrxCtrl', {
        isConnoteMode: false,
        allowReceiverCustomerLookup: false,
        entryLabel: 'Outbound',
        saveHeaderText: 'Simpan Outbound',
        deleteHeaderText: 'Hapus Outbound',
        defaultDataUrl: '/outbound-entry-defaultdata',
        entryDataUrl: '/outbound-entry-data/',
        printUrl: '/outbound-print',
        apiBaseUrl: 'api/outbound',
        generateAwbUrl: 'api/outbound/generate-awb',
        chargePreviewUrl: 'api/outbound/charge-preview',
        shipperCustomerListUrl: 'api/outbound/customer-list?',
        shipperCustomerLookupUrl: 'api/outbound/customer-code/',
        receiverCustomerListUrl: 'api/outbound/customer-list?',
        receiverCustomerLookupUrl: 'api/outbound/customer-code/',
        deleteDeniedMessage: 'Anda tidak memiliki otoritas hapus outbound'
    });
}
